module.exports = __webpack_public_path__ + "media/icon/favicon-16x16-e08b948e.png";